import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import { SpaceBetweenDiv, FlexDiv, Image } from './containers';
import { Heading1, Heading2 } from './headings';

const StyledBigModal = styled(Modal)`
    background-color: white;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    width: ${(props) => props.width}px;
    max-width: 90%;
    max-height: 70vh;
`;

const fullScreenModalStyles = {
    content: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        padding: 0,
    },
};

const PageCentralizedHeading2 = styled(Heading2)`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
`;

export function BigModal({
    heading,
    modalContent,
    modalFooterContent,
    isOpen,
    onRequestClose,
    extraHeaderContent,
    filterContent,
    shouldCloseOnOverlayClick = true,
    width = 900,
    headerStyle = {},
    overlayZIndex,
}) {
    const headingText = <Heading1>{heading}</Heading1>;
    return (
        <StyledBigModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            width={width}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            style={
                overlayZIndex
                    ? { overlay: { zIndex: overlayZIndex } }
                    : undefined
            }
        >
            <SpaceBetweenDiv
                minHeight={80}
                px={48}
                dropShadowBelow
                style={headerStyle}
                positionRelative
            >
                <FlexDiv gap={8}>
                    {extraHeaderContent ? (
                        <FlexDiv column>
                            <Heading2>{headingText}</Heading2>
                            {extraHeaderContent}
                        </FlexDiv>
                    ) : (
                        <Heading2>{headingText}</Heading2>
                    )}
                </FlexDiv>

                <FlexDiv gap={24} alignCenter>
                    <FlexDiv $noWrap gap={16}>
                        {filterContent}
                        <Image
                            src="/static/img/close.svg"
                            alt="Close"
                            onClick={onRequestClose}
                            link
                        />
                    </FlexDiv>
                </FlexDiv>
            </SpaceBetweenDiv>
            <ModalBody>{modalContent}</ModalBody>
            {modalFooterContent && (
                <FlexDiv
                    maxHeight={96}
                    px={48}
                    py={24}
                    dropShadowAbove
                    justifyEnd
                    alignCenter
                    gap={16}
                >
                    {modalFooterContent}
                </FlexDiv>
            )}
        </StyledBigModal>
    );
}

export function ModalBody({ children }) {
    return (
        <FlexDiv column py={32} px={48} overflowYauto $noWrap>
            {children}
        </FlexDiv>
    );
}

export function FullscreenModal({
    heading,
    modalContent,
    isOpen,
    onRequestClose,
    logo,
}) {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={fullScreenModalStyles}
        >
            <SpaceBetweenDiv
                minHeight={70}
                px={48}
                dropShadowBelow
                positionRelative
            >
                {logo}
                <PageCentralizedHeading2>{heading}</PageCentralizedHeading2>
                <Image
                    src="/static/img/close.svg"
                    alt="Close"
                    onClick={onRequestClose}
                    link
                />
            </SpaceBetweenDiv>
            {modalContent}
        </Modal>
    );
}
